import styled from 'styled-components';
import { FlexColumn, FlexibleDiv } from '../../styled/common';
import { globalSystemColors as systemColors } from '../../styled/theme/constants';
import { PlaceholderBlock } from '../../styled/placeholders.styled';
import UserIcon from '../../public/static/images/icon-user-in-circle--black.svg';

export const SelectedButton = styled(FlexibleDiv)`
  width: 88px;
  gap: 11px;
  align-items: center;
  position: relative;
  cursor: pointer;
  height: 44px;
  padding: 10px 15px;
  border-radius: 14px;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.colors.background.tertiary};
`;

export const LoginArrowContainer = styled.div`
  transition: transform 0.2s linear;
  transform: ${({ $isShowDropdown }) =>
    `rotate(${$isShowDropdown ? 180 : 0}deg)`};
`;

export const SelectedButtonUserIcon = styled.i`
  display: flex;
  align-items: center;
  gap: 10px;

  svg circle {
    fill: ${({ theme }) => theme.colors.text.primary};
    transition: fill 0.3s ease-in-out;
  }

  svg path {
    fill: ${({ theme }) => theme.colors.text.primary};
    transition: fill 0.3s ease-in-out;
  }

  &:hover {
    svg circle {
      fill: ${({ theme }) => theme.colors.background.primary};
      stroke: ${({ theme }) => theme.colors.background.primary};
    }

    svg path {
      fill: ${systemColors.blue};
      transition: fill 0.2s linear;
    }
  }
`;

export const DropdownItemsContainer = styled(FlexColumn)`
  position: absolute;
  z-index: 9999;
  top: 54px;
  right: 0;
  width: 280px;
  padding: 20px 10px;
  flex-direction: column;
  border-radius: 14px;
  overflow: hidden;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.colors.loginButton.bg};
  box-shadow: 0 5px 12px 0 rgba(0, 0, 0, 0.05);
`;

const BaseDropdownItem = styled.div`
  display: flex;
  height: 50px;
  padding: 0 10px;
  align-items: center;
  gap: 10px;
  font-size: 15px;
  color: ${({ theme }) => theme.colors.text.primary};
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
  border-radius: 14px;
  background-color: ${({ theme }) => theme.colors.loginButton.bg};
  cursor: pointer;

  &:hover {
    color: ${systemColors.blue};
    background-color: ${({ theme }) => theme.colors.loginButton.hoveredBorder};
  }
`;

export const DropDownProfileLink = styled(BaseDropdownItem).attrs({
  as: 'a'
})``;

export const DropdownItem = styled(BaseDropdownItem).attrs({ as: 'div' })``;

export const UserContactContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  padding-left: 15px;
`;

export const UserContainer = styled(FlexibleDiv)`
  margin: 10px;
  align-items: center;
`;

export const UserIconStyled = styled(UserIcon)`
  path {
    fill: ${({ theme }) => theme.colors.text.primary};
  }
`;

export const UserItem = styled.div`
  overflow: hidden;
  color: ${({ theme }) => theme.colors.text.primary};
  text-overflow: ellipsis;
  font-size: 16px;
  font-weight: 700;
`;

export const SignInButton = styled.button`
  width: 88px;
  position: relative;
  height: 44px;
  padding: 10px 15px;
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 15px;
  border-radius: 14px;
  text-decoration: none;
  box-sizing: border-box;
  transition: color 0.3s linear;
  line-height: 24px;
  cursor: pointer;
  background-color: ${({ theme }) => theme.colors.loginButton.bg};
  border: 1px solid ${({ theme }) => theme.colors.loginButton.border};

  &:hover {
    color: ${({ theme }) => theme.colors.systemColors.blue};
    background-color: ${({ theme }) => theme.colors.background.tertiary};
    border: 1px solid ${({ theme }) => theme.colors.loginButton.hoveredBorder};
  }
`;

export const InitialSignInButton = styled(SignInButton)`
  border-color: ${({ theme }) => theme.colors.background.primary};
  ${PlaceholderBlock};

  span {
    opacity: 0;
  }
`;
